import app from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID
};

class Firebase {
  constructor() {
    app.initializeApp(config);
    this.app = app;
    this.auth = app.auth();
    this.db = app.firestore();
    this.storage = app.storage();
  }

  // *** Auth API ***

  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);
  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password);

  doSignOut = () => {
    this.auth.signOut();
    window.location.href = "/sign-in";
  };

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);
  doPasswordUpdate = password => this.auth.currentUser.updatePassword(password);
  doEmailUpdate = email => this.auth.currentUser.updateEmail(email);

  // Provider
  async doCreateUserWithGoogleAccount() {
    const provider = new this.app.auth.GoogleAuthProvider();

    provider.addScope("profile");
    provider.addScope("email");
    console.log(provider);
    const promise = new Promise((resolve, reject) => {
      this.auth
        .signInWithPopup(provider)
        .then(result => {
          resolve(result);
        })
        .catch(error => reject(new Error(error)));
    });

    return await promise;
  }

  async getCurrentUser() {
    const promise = new Promise((resolve, reject) => {
      if (this.auth.currentUser) {
        this.auth.currentUser
          ? resolve(this.auth.currentUser)
          : reject(new Error("User not found"));
      }
    });

    return await promise;
  }

  // *** User API ***
  user = uid => {
    return this.db.collection("users").doc(uid);
  };
  users = () => this.db.collection("users");

  async userByUsername(userName) {
    const promise = new Promise((resolve, reject) => {
      this.db
        .collection("users")
        .where("userName", "==", userName)
        .get()
        .then(resolve)
        .catch(reject);
    });

    return await promise;
  }

  async usernameAvailable(name, uid) {
    const promise = new Promise((resolve, reject) => {
      this.db
        .collection("users")
        .where("userName", "==", name)
        .onSnapshot(snapshot => {
          if (snapshot.docs.length) {
            snapshot.docs[0].id === uid ? resolve(true) : reject(false);
          }

          snapshot.empty ? resolve(snapshot.empty) : reject(snapshot.empty);
        });
    });
    return await promise;
  }

  // *** Project API ***
  project = uid => {
    return this.db.collection("projects").doc(uid);
  };

  async projectExists(uid) {
    const promise = new Promise((resolve, reject) => {
      this.db
        .collection("projects")
        .doc(uid)
        .onSnapshot(doc => {
          doc.exists ? resolve(doc.exists) : reject(doc.exists);
        });
    });

    return await promise;
    // return docExists;
  }

  async projectBelongsToUser(uid) {
    const promise = new Promise((resolve, reject) => {
      this.db
        .collection("projects")
        .doc(uid)
        .onSnapshot(doc => {
          if (this.auth.currentUser) {
            if (doc.data()) {
              doc.data().user.id === this.auth.currentUser.uid
                ? resolve(doc.data())
                : reject(false);
            } else {
              reject(false);
            }
          } else {
            reject(false);
          }
        });
    });

    return await promise;
  }

  projects = () => {
    return this.db.collection("projects");
  };

  projectsByUser = uid => {
    return this.db.collection("projects").where("user.id", "==", uid);
  };

  // *** Heart API ***
  heartProject = (uid, likes) => {
    return this.db
      .collection("projects")
      .doc(uid)
      .update({ likes: likes + 1 });
  };

  // *** Storage API ***
  getStorageRef = () => this.storage.ref();
}

export default Firebase;
